export function formatNumber(number, info) {
    const rounded = typeof info === 'boolean' ? info : false;

    if (!number && number !== 0) {
        return 0;
    }

    if (number === '.') {
        return '.';
    }

    if (typeof number === 'string' && number.endsWith('.')) {
        const parts = number.split('.');
        const integerPart = parts[0] || '0';
        return `${integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.`;
    }

    let numberValue = typeof number === 'string' ? parseFloat(number) : number;

    if (rounded) {
        const integerPart = Math.floor(numberValue);
        const decimalPart = numberValue - integerPart;
        numberValue = decimalPart >= 0.5 ? Math.ceil(numberValue) : Math.floor(numberValue);
    }

    numberValue = Number((Math.round(numberValue * 1e3) / 1e3).toFixed(3));

    const parts = numberValue.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return parts.join('.');
}

class ConvertNumberToCurrency {
    formatNumberToVND = (number) => {
        return `${formatNumber(number)} VNĐ`;
    }

    formatMoney = (number) => {
        let formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return `${formattedNumber} VNĐ`;
    }
}

const convertNumberToCurrency = new ConvertNumberToCurrency();
export default convertNumberToCurrency;